import { Grid2 } from "@mui/material"
import CustomAccordion from "../../../../components/ui/materialui/customAccordion"
import { ResumenImportacionDto } from "../models/resumenImportacionDto"
import { useForm } from "react-hook-form"
import InputText from "../../../../components/inputs/yup/materialui/inputText"
import InputNumber from "../../../../components/inputs/yup/materialui/inputNumber"
import InputFecha from "../../../../components/inputs/yup/materialui/inputFecha"
import { useEffect } from "react"
import { TipoProducto } from "../../../../utils/enums"

interface IProps {
    resumen: ResumenImportacionDto
    isShowing: boolean
}

export const ResumenTableForm = ({ resumen, isShowing }: IProps) => {

    const { control, setValue, watch } = useForm<ResumenImportacionDto>({})

    const isEmisorDisponible = isShowing && resumen.emisor

    useEffect(() => {
        if (resumen) {
            setValue("nombre", resumen.nombre)
            setValue("totalDividendos", resumen.totalDividendos)
            setValue("periodosAnio", resumen.periodosAnio)
            setValue("fechaProtocolizacion", resumen.fechaProtocolizacion)
            setValue("tasaAnual", resumen.tasaAnual)
            setValue("numeroProtocolizacion", resumen.numeroProtocolizacion)
            setValue("plazoAnual", resumen.plazoAnual)
            setValue("notaria", resumen.notaria)
            setValue("mesesGraciaK", resumen.mesesGraciaK)
            setValue("mesesGraciaKI", resumen.mesesGraciaKI)
            setValue("numeroRepertorio", resumen.numeroRepertorio)
            setValue("tipoProducto", resumen.tipoProducto)
            setValue("plazoDivReducido", resumen.plazoDivReducido)
            setValue("porcAmortizacion", resumen.porcAmortizacion)

            if (isEmisorDisponible) {
                setValue("emisor", resumen.emisor)
            }
        }
    }, [resumen])

    const watcher = watch();

    return (
        <CustomAccordion
            title='Resumen de importación'
            expandedDefault
        >
            <Grid2 container spacing={2} sx={{ marginTop: 1 }}>
                <Grid2 size={{ xs: 12, lg: 3 }}>
                    <InputText
                        name={"nombre"}
                        control={control}
                        label="Nombre"
                        desabilitado
                        readonly
                    />
                </Grid2>
                <Grid2 size={{ xs: 12, lg: 3 }}>
                    <InputNumber
                        name={"totalDividendos"}
                        control={control}
                        decimales={0}
                        label="Total dividendos"
                        readonly
                        disabled
                    />
                </Grid2>
                <Grid2 size={{ xs: 12, lg: 3 }}>
                    <InputNumber
                        name={"periodosAnio"}
                        control={control}
                        decimales={0}
                        label="Periodos al año"
                        readonly
                        disabled
                    />
                </Grid2>
                <Grid2 size={{ xs: 12, lg: 3 }}>
                    <InputFecha
                        name="fechaProtocolizacion"
                        control={control}
                        label="Fecha de protocolización"
                        esReadOnly
                        disabled
                        fecha={watcher.fechaProtocolizacion}
                    />
                </Grid2>
                <Grid2 size={{ xs: 12, lg: 3 }}>
                    <InputNumber
                        name={"tasaAnual"}
                        control={control}
                        decimales={2}
                        label="Tasa anual"
                        readonly
                        disabled
                        suffix="%"
                    />
                </Grid2>
                <Grid2 size={{ xs: 12, lg: 3 }}>
                    <InputText
                        name={"numeroProtocolizacion"}
                        control={control}
                        label="Número protocolización"
                        desabilitado
                        readonly
                    />
                </Grid2>
                <Grid2 size={{ xs: 12, lg: 3 }}>
                    <InputNumber
                        name={"plazoAnual"}
                        control={control}
                        decimales={0}
                        label="Plazo anual"
                        readonly
                        disabled
                    />
                </Grid2>
                <Grid2 size={{ xs: 12, lg: 3 }}>
                    <InputText
                        name={"notaria"}
                        control={control}
                        label="Notaria"
                        desabilitado
                        readonly
                    />
                </Grid2>
                <Grid2 size={{ xs: 12, lg: 3 }}>
                    <InputNumber
                        name={"mesesGraciaK"}
                        control={control}
                        decimales={0}
                        label="Meses de gracia k"
                        readonly
                        disabled
                    />
                </Grid2>
                <Grid2 size={{ xs: 12, lg: 3 }}>
                    <InputNumber
                        name={"mesesGraciaKI"}
                        control={control}
                        decimales={0}
                        label="Meses de gracia k+i"
                        readonly
                        disabled
                    />
                </Grid2>
                <Grid2 size={{ xs: 12, lg: 3 }}>
                    <InputText
                        name={"numeroRepertorio"}
                        control={control}
                        label="Número repertorio"
                        desabilitado
                        readonly
                    />
                </Grid2>
                <Grid2 size={{ xs: 12, lg: 3 }}>
                    <InputText
                        name={"tipoProducto"}
                        control={control}
                        label="Tipo producto"
                        desabilitado
                        readonly
                    />
                </Grid2>
                {
                    isShowing ?
                        <Grid2 size={{ xs: 12, lg: 3 }}>
                            <InputText
                                name={"emisor"}
                                control={control}
                                label="Emisor"
                                desabilitado
                                readonly
                            />
                        </Grid2>
                        : <></>
                }
                {
                    watcher.tipoProducto === TipoProducto.MHD &&
                    <>
                        <Grid2 size={{ xs: 12, lg: 3 }}>
                            <InputNumber
                                name={"plazoDivReducido"}
                                control={control}
                                decimales={0}
                                label="Plazo div reducido"
                                readonly
                                disabled
                            />
                        </Grid2>
                        <Grid2 size={{ xs: 12, lg: 3 }}>
                            <InputNumber
                                name={"porcAmortizacion"}
                                control={control}
                                decimales={2}
                                label="Porc amortización"
                                readonly
                                disabled
                            />
                        </Grid2>
                    </>
                }
            </Grid2>
        </CustomAccordion>
    )
}